<template>
  <div class="q-pa-xs">
    <ECharts
      v-if="closePrice"
      :option="this.$q.dark.mode == false ? lightOptions : darkOptions"
      class="q-mt-md"
      :resizable="true"
      autoresize
      :style="`height: ${chartHeight}px;`"
    />
  </div>
</template>
<script>
import { ref, computed, onMounted, reactive, defineAsyncComponent } from "vue";

import useData from "src/use/data";
import useMarket from "src/use/market";
import { LocalStorage, useQuasar } from "quasar";
import moment from "moment";

import * as echarts from "echarts";
import ECharts from "vue-echarts";

import VueApexCharts from "vue3-apexcharts";
export default {
  props: {
    chartHeight: {
      type: Number,
      default: 335,
    },
  },
  components: {
    ECharts,
  },
  setup(props) {
    const {
      historyDataSearch,
      intraStockPerformance,
      indexPerformance,
      stockPerformance,
      weeklyNepse,
    } = useData();

    const options = ref({});
    const lightOptions = ref({});
    const darkOptions = ref({});
    const closePrice = ref([]);
    const dates = ref([]);
    const colors = ref([]);

    weeklyNepse().then((res) => {
      const data = res.data.reverse();

      const closePriceData = data.map((item) => item.close);
      const datesData = data.map((item) => item.date);

      colors.value = closePriceData
        .map((price, i) =>
          i > 0 && price > closePriceData[i - 1] ? "#089981" : "#F23645"
        );

      closePrice.value = closePriceData;
      dates.value = datesData;

      function generateChartOptions(labelTextColor, yAxisColor) {
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          grid: {
            left: "2%",
            right: "2%",
            top: "6%",
            bottom: "5%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: dates.value.map((value) => {
                const date = new Date(value);
                const month = date.getMonth() + 1;
                const day = date.getDate();
                return `${month}-${day}`;
              }),
              axisLabel: {
                textStyle: {
                  color: labelTextColor,
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              axisLine: {
                lineStyle: { color: yAxisColor, type: "dashed" },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: labelTextColor,
                },
              },
              splitLine: { lineStyle: { type: "dashed" } },
              axisTick: {
                show: true,
                lineStyle: { color: yAxisColor, type: "dashed" },
              },
              min: Math.min(...closePrice.value) - 10,
              max: Math.max(...closePrice.value),
            },
          ],
          series: [
            {
              name: "Nepse Line",
              type: "line",
              data: closePrice.value,
              lineStyle: {
                color: "#3acc88",
              },
              itemStyle: {
                color: "#37474F",
              },
              label: {
                show: true,
                position: "top",
                formatter: "{c}",
                color: labelTextColor,
              },
            },
            {
              name: "Nepse Bar",
              type: "bar",
              data: closePrice.value,
              itemStyle: {
                color: (params) => colors.value[params.dataIndex],
              },
            },
          ],
        };
      }

      lightOptions.value = generateChartOptions("black", "rgba(0, 0, 0, .54)");
      darkOptions.value = generateChartOptions("white", "rgba(0, 0, 0, .54)");
    });
    return {
      options,
      lightOptions,
      darkOptions,
      closePrice,
    };
  },
};
</script>
